<template>
  <div id="data_permission_set">
    <!-- 左边树结构 -->
    <div class="left_tree_box pt-3" :class="{ hidden_content: hiddenLeftTree }">
      <div class="move_box" @click="hiddenLeftTree = !hiddenLeftTree">
        <svg-icon icon-class="collapse-border" class="move_collapse"></svg-icon>
        <svg-icon icon-class="collapse-border-active" class="move_collapse_active"></svg-icon>
      </div>
      <el-radio-group v-model="listType" size="small" style="margin-left: 10px">
        <el-radio-button label="role">按角色</el-radio-button>
        <el-radio-button label="depart">按部门</el-radio-button>
        <el-radio-button label="user">按用户</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 8px; padding: 0 10px 0 10px">
        <el-input
          v-model="leftSearchText"
          class="self-filter-input"
          placeholder="搜索"
          clearable
          @keyup.enter.native="leftFilterTree"
          @input="leftFilterTree"
          @clear="leftFilterTree"
        >
          <i slot="suffix" style="padding-right: 8px" @click="leftFilterTree">
            <svg-icon icon-class="input_search"></svg-icon>
          </i>
        </el-input>
      </div>

      <span class="vertical-bar fnM" :style="{ marginLeft: '16px' }">授权对象</span>
      <el-tree
        ref="leftTree"
        style="margin-top: 16px; height: calc(100% - 138px); overflow-y: auto"
        class="self-tree data_tree"
        node-key="id"
        :props="leftDefaultProps"
        :data="leftTreeData"
        :highlight-current="true"
        :filter-node-method="filterNode"
        :default-expanded-keys="leftDefaultShowNodes"
        :expand-on-click-node="false"
        @node-click="leftHandleNodeClick"
        @node-expand="leftHandleNodeExpand"
        @node-collapse="leftHandleNodeCollapse"
      >
        <span
          slot-scope="{ node }"
          :title="node.label"
          class="self-custom-tree"
          style="line-height: 32px"
        >
          <span style="padding-right: 10px">
            <span v-html="leftHandleFilter(node.label)"></span>
          </span>
        </span>
      </el-tree>
    </div>
    <!-- 中间树结构 -->
    <div class="tree_content">
      <permission-interface
        class="h100"
        :target-id="leftCurrentNode.id"
        :target-type="listType === 'role' ? '2' : listType === 'depart' ? '1' : '3'"
      ></permission-interface>
    </div>
  </div>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";
import PermissionInterface from "@/views/standard/permission/components/assign-permission-interface";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";
export default {
  name: "PermissionInterfaceData",
  components: {
    PermissionInterface
  },
  data() {
    return {
      listType: "role",
      selectValue: "",
      checkTypeUser: true,
      checkTypeField: false,
      hiddenLeftTree: false,
      fieldVisible: false,
      activeName: null,
      leftDefaultProps: {
        children: "children",
        label: "roleName"
      },
      defaultProps: {
        children: "children",
        label: "resourceName"
      },
      leftCurrentNode: "",
      leftSearchText: "",
      leftFilterText: "",
      leftTreeData: [],
      defaultShowNodes: [],
      leftDefaultShowNodes: []
      //   departTree: [],
      //   departCheckedIds: [],
      //   setData: '',
      //   tabsList: [],
      //   previewType: '',
      //   previewTable: [],
      //   tableKeys: [],
      //   previewData: [],
      //   previewTreeProps: { children: 'children', label: 'name' },
      //   previewKeyName: '',
      //   previewCheckedIds: [],
      //   tableSelectData: [],
      //   treeType: null,
      //   saveKeyField: '',
      //   bizUnitRulesId: '',
      //   deleteIds: []
    };
  },
  computed: {
    ...mapGetters(["tenantId", "infoData"])
  },
  watch: {
    listType(str) {
      this.leftCurrentNode = "";
      this.leftDefaultShowNodes = [];
      this.getFirstTreeList();
    },
    checkTypeUser(bool) {
      if (bool) {
        this.getCurrentPermission();
      }
    },
    checkTypeField(bool) {
      if (bool) {
        this.getFieldDetail();
      } else {
        this.activeName = null;
      }
    },
    activeName(str, old) {
      if (str) {
        // this.previewCheckedIds = [];
        this.tabsList.forEach(item => {
          if (item.resourceElementId === str) {
            this.getCurrentPermission(() => {
              this.getFieldTabInfo(item);
            }, true);
          }
        });
      }
    },
    selectValue() {
      console.log(this.departTree);
    }
  },
  created() {
    const that = this;
    window.onresize = function() {
      if (document.body.clientWidth < 1400) {
        that.hiddenLeftTree = true;
      }
    };
    this.getFirstTreeList();
    this.getDepartTree();
  },
  methods: {
    // 重置左边树选中展开节点
    initLeftCurrent() {
      this.$nextTick(() => {
        if (!this.leftCurrentNode || this.leftCurrentNode === "") {
          this.leftCurrentNode = this.leftTreeData[0] || {};
          this.leftDefaultShowNodes.push(this.leftTreeData[0].id);
        }

        this.$refs.leftTree && this.$refs.leftTree.setCurrentKey(this.leftCurrentNode.id);
        // if (this.centerCurrentNode) {
        //   this.checkPermissionSet(() => {
        //     if (this.checkTypeUser) {
        //       this.getCurrentPermission();
        //     }
        //     if (this.checkTypeField) {
        //       this.getFieldDetail();
        //     }
        //   });
        // }
      });
    },
    // 获取最左边树结构
    getFirstTreeList() {
      if (this.listType === "role") {
        dataApi.getRoleList({
          createOrg: this.infoData.belongOrgId
        }).then(res => {
          this.leftDefaultProps.label = "roleName";
          this.leftTreeData = res.data;
          this.initLeftCurrent();
        });
      }
      if (this.listType === "depart") {
        dataApi.getOrganization({ parseToTree: true, withUser: true }, this.tenantId).then(res => {
          this.leftDefaultProps.label = "orgName";
          this.leftTreeData = [res.data];
          this.initLeftCurrent();
        });
      }
      if (this.listType === "user") {
        dataApi.getUsersTree({}).then(res => {
          this.leftDefaultProps.label = "displayName";
          this.leftTreeData = res.data;
          this.initLeftCurrent();
        });
      }
    },

    // 手动过滤
    leftHandleFilter(str) {
      if (!this.leftFilterText || !str) {
        return str;
      }
      const index = str.indexOf(this.leftFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.leftFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.leftFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    handleFilter(str) {
      if (!this.centerFilterText || !str) {
        return str;
      }
      const index = str.indexOf(this.centerFilterText);
      const beforeStr = str.substr(0, index);
      const afterStr = str.substr(index + this.centerFilterText?.length);
      if (index > -1) {
        return `${beforeStr}<span style="color:#00B259;">${this.centerFilterText}</span>${afterStr}`;
      } else {
        return str;
      }
    },
    // 筛选树
    leftFilterTree() {
      this.leftFilterText = this.leftSearchText;
      this.$refs.leftTree.filter(this.leftSearchText);
    },
    //  树过滤
    filterTree() {
      this.centerFilterText = this.centerSearchText;
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // 树节点展开
    leftHandleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.leftDefaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.leftDefaultShowNodes.push(data.id);
      }
    },
    leftHandleNodeCollapse(data) {
      this.leftDefaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.leftDefaultShowNodes.length = i;
        }
      });
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 节点点击
    leftHandleNodeClick(node) {
      this.leftCurrentNode = node;
    },

    // 获取部门树列表
    getDepartTree(cb) {
      this.departCheckedIds = [];
      dataApi.getOrganization({ parseToTree: true, withUser: true }, this.tenantId).then(res => {
        this.departTree = [res.data];
        cb && cb();
      });
    },

    // 部门树选择
    departCheckChange() {
      this.departCheckedIds = this.$refs.depart_tree.getCheckedKeys();
      console.log(this.departCheckedIds);
    },
    checkChange(bool, str) {
      /*
       * if (bool) {
       *   if (str === "user") {
       *     this.checkTypeUser = true;
       *     this.checkTypeField = false;
       *   } else {
       *     this.checkTypeUser = false;
       *     this.checkTypeField = true;
       *   }
       * } else {
       *   if (str === "user") {
       *     this.checkTypeUser = true;
       *   } else {
       *     this.checkTypeField = true;
       *   }
       * }
       */
    },
    // 表格选项变更
    tableSelectChange(val) {
      this.previewCheckedIds = [];
      val.forEach(item => {
        this.previewCheckedIds.push(item[this.previewKeyName]);
      });
    },
    // 字段树选项变更
    fieldTreeCheckChange() {
      this.previewCheckedIds = this.$refs.field_tree.getCheckedKeys();
    },

    tabHandleClick() {
      /*
       * this.tableSelectData = [];
       * this.getCurrentPermission(() => {}, true);
       */
    },
    // 点击tab选项卡
    getFieldTabInfo(i) {
      dataApi.getFieldDetail({ ids: [i.bizUnitId] }).then(res => {
        this.saveKeyField = i.keyField;
        const obj = res.data[0] || {};
        this.previewType = obj.displayDataType === 1 ? "table" : "tree";
        const displayData = JSON.parse(obj.displayData);
        console.log("previewType", this.previewType);
        if (this.previewType === "table") {
          this.previewTable = JSON.parse(obj.restfulValues);

          /*
           * if (!this.previewKeyName) {
           *   this.previewKeyName = obj.keyField;
           * }
           */
          this.previewKeyName = obj.keyField;
          this.tableKeys = JSON.parse(obj.displayData);
          if (this.previewCheckedIds.length > 0) {
            //  填充选中值
            const arr = [];
            this.previewTable.forEach(item => {
              this.previewCheckedIds.forEach(el => {
                if (item[this.previewKeyName] === el) {
                  arr.push(item);
                }
              });
            });
            console.log(this.$refs.customTable, this.$refs);
            this.$nextTick(() => {
              this.tableSelectData = [...arr];
              console.log("asas", this.tableSelectData);
            });

            /*
             * setTimeout(() => {
             *   this.tableSelectData = [...arr];
             * });
             */
          }
        } else {
          this.previewData = JSON.parse(obj.restfulValues);
          this.previewTreeProps.name = displayData.code;

          /*
           * if (!this.previewKeyName) {
           *   this.previewKeyName = obj.keyField;
           * }
           */
          this.previewKeyName = obj.keyField;
          this.treeType = obj.treeType;
          if (this.previewCheckedIds.length > 0) {
            this.$nextTick(() => {
              console.log("asfasf", this.previewCheckedIds, this.$refs);
              this.$refs.field_tree.setCheckedKeys(this.previewCheckedIds);
            });
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#data_permission_set {
  width: 100%;
  height: 100%;
  display: flex;
  .left_tree_box {
    position: relative;
    transition: all 0.25s linear;
    flex: 0 224px;
    background-color: #f9f9fb;
    border-right: 1px solid #dcdfe6;
    width: 224px;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .hidden_content {
    margin-left: -224px;
    flex: inherit;
  }
  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }

  .move_box {
    position: absolute;
    right: -34px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    z-index: 99;
    cursor: pointer;
    .move_collapse {
      display: block;
    }

    .move_collapse_active {
      display: none;
    }

    &:hover {
      .move_collapse {
        display: none;
      }
      .move_collapse_active {
        display: block;
      }
    }
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    min-width: calc(100% - 224px);

    ::v-deep .tree-tabs-wrapper {
      .el-radio-button {
        .el-radio-button__inner {
          padding: 8px 10px;
          width: 103px;
          font-size: 12px;
        }
      }
    }
    .center_tree_box {
      border-right: 1px solid #dcdfe6;
      background-color: #fff;
      flex: 0 224px;
      position: relative;
    }
    .right_content {
      padding: 30px;
      overflow-y: auto;
      .select_box {
        margin: 20px 0 24px 0;
        .check_label {
          color: #21252e;
        }
      }
      .depart_box {
        width: 100%;
        height: 300px;
        border: 1px solid #d4d9e2;
        overflow-y: auto;
      }
      .no_content_box {
        margin-top: 16px;
        width: 100%;
        background-color: #f9f9fb;
        padding: 16px;
        .tips {
          color: #606266;
          margin-right: 16px;
        }
      }
    }
  }
  .preview_box {
    overflow-y: auto;
    width: 100%;
    border: 1px solid #dcdfe6;
    height: 100%;
  }
  .h5_title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  .plain_button {
    color: #505363;
    background-color: #fff;
  }
  .plain_button:hover {
    color: #00b259;
  }
  .plain_button:focus {
    color: #00b259;
  }
}
</style>

<style lang="scss">
#data_permission_set {
  .el-radio-group {
    margin-top: 0;
  }
  .self-filter-input {
    margin-bottom: 20px;
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .left_tree_box .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 66px;
      font-size: 14px;
    }
  }

  .el-button--small {
    padding: 8px 16px;
    box-shadow: none;
  }
  .el-tabs {
    .el-tabs__item {
      min-width: 88px;
      text-align: center;
      padding: 0;
    }
  }

  .field_dialog {
    .el-dialog {
      width: 1084px;
      .el-dialog__header {
        padding: 24px 40px 8px 40px;
      }
      .el-dialog__body {
        padding: 6px 40px;
        // .suffix_icon {
        //   width: 14px;
        //   height: 14px;
        //   position: relative;
        //   top: 1px;
        //   right: 5px;
        // }
      }
    }
  }

  //   重写table样式-小型
  .small_table {
    .el-table {
      th {
        padding: 6px 0;
        height: 36px;
      }
      th:first-child {
        padding-left: 10px;
      }
      .el-input {
        margin-bottom: 0;
        .el-input__inner {
          height: 24px;
          line-height: 24px;
        }
      }
      td {
        padding: 4px 0;
        height: 32px;
      }
      td:first-child {
        padding-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
      .el-pagination__total {
        height: 24px;
        line-height: 24px;
      }
      button {
        height: 24px;
        line-height: 24px;
        min-width: 24px;
      }
      .el-pager {
        .number {
          height: 24px;
          line-height: 24px;
          min-width: 24px;
        }
      }
      .pagination-jumper {
        height: 24px;
        line-height: 24px;
        input {
          width: 24px;
          height: 24px;
          line-height: 24px;
        }
      }
      .pagination-sizes {
        height: 24px;
        line-height: 24px;
        .pagination-select {
          height: 24px;
          .el-input {
            .el-input__inner {
              height: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
